import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { useMemo } from 'react';

import { useConfig } from '../../ConfigProvider';
import authLink from '../authLink';
import omitTypeNameLink from '../omitTypeNameLink';
import sentryLink from '../sentryLink';
import useErrorLink from '../useErrorLink';

const useClient = () => {
  // The bearer token is set by <AuthenticationProvider /> (rendered inside this
  // provider) through setAuthorization().
  const cache = useMemo(() => new InMemoryCache(), []);

  const errorLink = useErrorLink();
  const { marketplaceUrl } = useConfig();

  return useMemo(() => {
    const uploadLink = createUploadLink({ uri: marketplaceUrl });

    const link = authLink.concat(
      ApolloLink.from([omitTypeNameLink, errorLink, sentryLink, uploadLink]),
    );

    return new ApolloClient({
      cache,
      connectToDevTools: true,
      defaultOptions: {
        query: {
          errorPolicy: 'all',
          fetchPolicy: 'no-cache',
        },
        watchQuery: {
          errorPolicy: 'all',
          fetchPolicy: 'no-cache',
        },
      },
      link,
      queryDeduplication: false,
    });
  }, [cache, errorLink, marketplaceUrl]);
};

export default useClient;
